import useResizeObserver from './useResizeObserver'
export { type Sizes } from './useResizeObserver'

export default useResizeObserver
